import { IconButton, TextField, TextFieldProps } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import React, { useState } from 'react';

export const PasswordField = (props: TextFieldProps): React.ReactElement => {
    const [showPassword, setshowPassword] = useState(false);

    const handleClickShowPassword = (): void => {
        setshowPassword(!showPassword);
    };

    return (
        <TextField
            fullWidth
            required
            margin="dense"
            type={showPassword ? 'text' : 'password'}
            InputProps={{
                endAdornment: (
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                )
            }}
            {...props}
        />
    );
};
